import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/Button'

interface ReviewsModalProps {
  isOpen: boolean
  location: any | null
  reviews: any[]
  isLoadingReviews: boolean
  newRating: number
  newComment: string
  onClose: () => void
  onRatingChange: (rating: number) => void
  onCommentChange: (comment: string) => void
  onSubmitReview: () => void
}

export function ReviewsModal({
  isOpen,
  location,
  reviews,
  isLoadingReviews,
  newRating,
  newComment,
  onClose,
  onRatingChange,
  onCommentChange,
  onSubmitReview,
}: ReviewsModalProps) {
  const { t } = useTranslation()

  if (!isOpen || !location) return null

  return (
    <div className="fixed inset-0 bg-black/40 z-[10000] flex items-end sm:items-center justify-center pb-20 sm:pb-4">
      <div className="bg-white w-full sm:max-w-lg rounded-t-2xl sm:rounded-2xl p-4 sm:p-6">
        <div className="flex items-center justify-between mb-3">
          <h3 className="text-lg font-semibold text-text-primary">{location.location_name}</h3>
          <button className="text-gray-500" onClick={onClose}>✕</button>
        </div>
        <div className="max-h-64 overflow-y-auto border rounded-lg p-3 mb-4">
          {isLoadingReviews ? (
            <div className="text-sm text-text-secondary">{t('common.loading')}</div>
          ) : reviews.length === 0 ? (
            <div className="text-sm text-text-secondary">{t('merchants.noReviews') || 'Sem avaliações ainda'}</div>
          ) : (
            <div className="space-y-3">
              {reviews.map((r: any) => (
                <div key={r.id} className="border-b pb-2">
                  <div className="flex items-center text-yellow-500 text-sm">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <span key={i}>{i < (r.rating || 0) ? '★' : '☆'}</span>
                    ))}
                    <span className="ml-2 text-xs text-gray-500">{r.user_email || r.user?.email || ''}</span>
                  </div>
                  {r.comment && (
                    <div className="text-sm text-gray-700 mt-1">{r.comment}</div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
        <div className="mb-3">
          <div className="flex items-center gap-2 mb-2">
            {Array.from({ length: 5 }).map((_, i) => (
              <button
                key={i}
                className={`text-2xl ${i < newRating ? 'text-yellow-500' : 'text-gray-300'}`}
                onClick={() => onRatingChange(i + 1)}
              >
                ★
              </button>
            ))}
          </div>
          <textarea
            className="w-full border rounded-lg p-2 text-sm"
            rows={3}
            placeholder={t('merchants.writeReview') || 'Escreva um comentário (opcional)'}
            value={newComment}
            onChange={(e) => onCommentChange(e.target.value)}
          />
        </div>
        <div className="flex gap-2 justify-end">
          <Button variant="outline" size="sm" onClick={onClose}>
            {t('common.cancel')}
          </Button>
          <Button
            variant="primary"
            size="sm"
            onClick={onSubmitReview}
          >
            {t('common.submit')}
          </Button>
        </div>
      </div>
    </div>
  )
}
